import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { createContext, useContext } from 'react';
import * as commonStyle from '../css/common/common.css';
export const FabricsContext = createContext(null);
const canUseDOM = typeof window !== 'undefined';
export const FabricsProvider = ({ children, theme, ...context }) => {
    return (_jsx(FabricsContext.Provider, { value: { ...context, theme, canUseDOM }, children: _jsx("div", { className: clsx(theme.tokensClassName, commonStyle.typographyRoot), children: children }) }));
};
export const useFabricsContext = () => {
    const c = useContext(FabricsContext);
    if (c === null) {
        throw new Error('Fabrics context not found');
    }
    return c;
};
